"use strict";

var _slicedToArray = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/slicedToArray");

var _regeneratorRuntime = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/runner/work/hakka.finance/hakka.finance/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseChainId = void 0;

var types_1 = require("@web3-react/types");

var version_1 = require("./version");

if (typeof window !== 'undefined') {
  var _w = window;
  _w.UAUTH_VERSION = _w.UAUTH_VERSION || {};
  _w.UAUTH_VERSION.WEB3_REACT = version_1.VERSION;
}

function parseChainId(chainId) {
  return Number.parseInt(chainId, 16);
}

exports.parseChainId = parseChainId;

var UAuthConnector = /*#__PURE__*/function (_types_1$Connector) {
  _inherits(UAuthConnector, _types_1$Connector);

  var _super = _createSuper(UAuthConnector);

  function UAuthConnector(_ref) {
    var _this;

    var actions = _ref.actions,
        options = _ref.options,
        onError = _ref.onError;

    _classCallCheck(this, UAuthConnector);

    _this = _super.call(this, actions, onError);
    _this.options = options;
    return _this;
  }

  _createClass(UAuthConnector, [{
    key: "callbackAndActivate",
    value: function callbackAndActivate(options) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var activate, onError, throwErrors, callbackOptions;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return UAuthConnector.importUAuth();

              case 2:
                activate = options.activate, onError = options.onError, throwErrors = options.throwErrors, callbackOptions = __rest(options, ["activate", "onError", "throwErrors"]);

                if (!callbackOptions.url) {
                  _context.next = 8;
                  break;
                }

                _context.next = 6;
                return this.uauth.loginCallback(callbackOptions);

              case 6:
                _context.next = 10;
                break;

              case 8:
                _context.next = 10;
                return this.uauth.loginCallback();

              case 10:
                return _context.abrupt("return", activate(this, onError, throwErrors));

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "activate",
    value: function activate() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var cancelActivation, user;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cancelActivation = this.actions.startActivation();
                _context2.next = 3;
                return UAuthConnector.importUAuth();

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return this.uauth.user();

              case 6:
                user = _context2.sent;
                _context2.next = 26;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);

                if (this.uauth.fallbackLoginOptions.scope.includes('wallet')) {
                  _context2.next = 13;
                  break;
                }

                throw new Error('Must request the "wallet" scope for connector to work.');

              case 13:
                if (!this.options.shouldLoginWithRedirect) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 16;
                return this.uauth.login({
                  packageName: '@uauth/web3-react',
                  packageVersion: version_1.VERSION
                });

              case 16:
                _context2.next = 18;
                return new Promise(function () {});

              case 18:
                throw new Error('Should never get here.');

              case 21:
                _context2.next = 23;
                return this.uauth.loginWithPopup({
                  packageName: '@uauth/web3-react',
                  packageVersion: version_1.VERSION
                });

              case 23:
                _context2.next = 25;
                return this.uauth.user();

              case 25:
                user = _context2.sent;

              case 26:
                if (!(user.wallet_type_hint == null)) {
                  _context2.next = 28;
                  break;
                }

                throw new Error('no wallet type present');

              case 28:
                if (!['web3', 'injected'].includes(user.wallet_type_hint)) {
                  _context2.next = 32;
                  break;
                }

                this._subConnector = this.options.connectors.injected;
                _context2.next = 37;
                break;

              case 32:
                if (!(user.wallet_type_hint === 'walletconnect')) {
                  _context2.next = 36;
                  break;
                }

                this._subConnector = this.options.connectors.walletconnect;
                _context2.next = 37;
                break;

              case 36:
                throw new Error('Connector not supported');

              case 37:
                _context2.next = 39;
                return this._subConnector.activate();

              case 39:
                if (this._subConnector.provider) {
                  this.provider = this._subConnector.provider;
                }

                if (this.provider) {
                  _context2.next = 42;
                  break;
                }

                return _context2.abrupt("return", cancelActivation());

              case 42:
                this.provider.on('connect', function (_ref2) {
                  var chainId = _ref2.chainId;

                  _this2.actions.update({
                    chainId: parseChainId(chainId)
                  });
                });
                this.provider.on('disconnect', function (error) {
                  var _a; // 1013 indicates that MetaMask is attempting to reestablish the connection
                  // https://github.com/MetaMask/providers/releases/tag/v8.0.0


                  if (error.code === 1013) {
                    console.debug('MetaMask logged connection error 1013: "Try again later"');
                    return;
                  }

                  _this2.actions.resetState();

                  (_a = _this2.onError) === null || _a === void 0 ? void 0 : _a.call(_this2, error);
                });
                this.provider.on('chainChanged', function (chainId) {
                  _this2.actions.update({
                    chainId: parseChainId(chainId)
                  });
                });
                this.provider.on('accountsChanged', function (accounts) {
                  if (accounts.length === 0) {
                    // handle this edge case by disconnecting
                    _this2.actions.resetState();
                  } else {
                    _this2.actions.update({
                      accounts: accounts
                    });
                  }
                });
                return _context2.abrupt("return", Promise.all([this.provider.request({
                  method: 'eth_chainId'
                }), this.provider.request({
                  method: 'eth_requestAccounts'
                })]).then(function (_ref3) {
                  var _ref4 = _slicedToArray(_ref3, 2),
                      chainId = _ref4[0],
                      accounts = _ref4[1];

                  var receivedChainId = parseChainId(chainId);
                  return _this2.actions.update({
                    chainId: receivedChainId,
                    accounts: accounts
                  });
                }).catch(function (error) {
                  cancelActivation === null || cancelActivation === void 0 ? void 0 : cancelActivation();
                  throw error;
                }));

              case 47:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      var _a, _b;

      if (this._subConnector) {
        if (!this.uauth.fallbackLogoutOptions.rpInitiatedLogout) {
          this.uauth.logout({
            rpInitiatedLogout: false
          });
        }

        this.actions.resetState();

        if ((_a = this === null || this === void 0 ? void 0 : this._subConnector) === null || _a === void 0 ? void 0 : _a.deactivate) {
          void (this === null || this === void 0 ? void 0 : this._subConnector.deactivate());
        } else if ((_b = this === null || this === void 0 ? void 0 : this._subConnector) === null || _b === void 0 ? void 0 : _b.resetState) {
          void (this === null || this === void 0 ? void 0 : this._subConnector.resetState());
        }
      }
    }
  }, {
    key: "isAuthorized",
    value: function isAuthorized() {
      var _a;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var user;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.uauth.user();

              case 2:
                user = _context3.sent;
                return _context3.abrupt("return", Boolean(user && ((_a = this._subConnector) === null || _a === void 0 ? void 0 : _a.provider)));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getProvider",
    value: function getProvider() {
      var _a;

      return (_a = this.subConnector) === null || _a === void 0 ? void 0 : _a.provider;
    }
  }, {
    key: "uauth",
    get: function get() {
      var _a = this.options,
          connectors = _a.connectors,
          uauth = _a.uauth,
          shouldLoginWithRedirect = _a.shouldLoginWithRedirect,
          uauthOptions = __rest(_a, ["connectors", "uauth", "shouldLoginWithRedirect"]);

      if (uauth) {
        return uauth;
      }

      if (this._uauth) {
        return this._uauth;
      }

      if (UAuthConnector.UAuth == null) {
        throw new Error('Must import UAuth before constructing a UAuth Object');
      }

      if (!uauthOptions.clientID || !uauthOptions.redirectUri) {
        throw new Error('Incomplete constructor options');
      }

      this._uauth = new UAuthConnector.UAuth(uauthOptions);
      return this._uauth;
    }
  }, {
    key: "subConnector",
    get: function get() {
      if (this._subConnector == null) {
        throw new Error('no subconnector');
      }

      return this._subConnector;
    }
  }], [{
    key: "registerUAuth",
    value: function registerUAuth(pkg) {
      UAuthConnector.UAuth = pkg;
    }
  }, {
    key: "importUAuth",
    value: function importUAuth() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(UAuthConnector.UAuth == null)) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return Promise.resolve().then(function () {
                  return require('@uauth/js');
                }).then(function (m) {
                  var _a;

                  return (_a = m === null || m === void 0 ? void 0 : m.default) !== null && _a !== void 0 ? _a : m;
                });

              case 3:
                UAuthConnector.UAuth = _context4.sent;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }]);

  return UAuthConnector;
}(types_1.Connector);

exports.default = UAuthConnector;